export const CATEGORY_KINDS = ['main', 'side', 'drink', 'dessert', 'starter', 'combo', 'other'] as const;
export type CategoryKind = (typeof CATEGORY_KINDS)[number];

export const CATEGORY_KIND_LABELS: Record<CategoryKind, string> = {
  main: 'Prato principal',
  side: 'Acompanhamento',
  drink: 'Bebida',
  dessert: 'Sobremesa',
  starter: 'Entrada',
  combo: 'Menu / Combo',
  other: 'Outro',
};

export const WIZARD_STEPS = ['main', 'side', 'drink', 'dessert', 'details'] as const;
export type WizardStep = (typeof WIZARD_STEPS)[number];

export const WIZARD_STEP_LABELS: Record<WizardStep, string> = {
  main: 'Prato principal',
  side: 'Acompanhamentos',
  drink: 'Bebidas',
  dessert: 'Sobremesas',
  details: 'Os teus dados',
};

export type UpsellRuleType = 'cross_sell' | 'upsell';
export type UpsellTriggerType = 'item' | 'category' | 'keyword' | 'cart_missing_kind';
export type UpsellShowIn = 'cart' | 'wizard' | 'both';

export type UpsellRule = {
  id: string;
  name: string;
  rule_type: UpsellRuleType;
  trigger_type: UpsellTriggerType;
  trigger_item_ids: string[];
  trigger_category_ids: string[];
  trigger_keywords: string[];
  suggest_item_ids: string[];
  suggest_category_ids: string[];
  suggest_kinds: CategoryKind[];
  message: string | null;
  priority: number;
  is_active: boolean;
  show_in: UpsellShowIn;
};

export type OrderWizardSettings = {
  enabled: boolean;
  allow_skip: boolean;
};

export type MenuCategoryWithKind = {
  id: string;
  name: string;
  sort_order: number;
  image?: string | null;
  kind: CategoryKind;
};

export type PublicMenuItem = {
  id: string;
  category_id: string;
  name: string;
  description: string;
  price: number;
  image?: string | null;
};

export type UpsellSuggestion = {
  rule_id: string;
  rule_name: string;
  rule_type: UpsellRuleType;
  message: string;
  items: PublicMenuItem[];
};
